import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import { TypesValidation } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Form, Radio } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';

import IExecutionComponent from '../interfaces/IExecutionComponent';

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};
export interface ISelectExecutionProps extends IExecutionComponent {
  description: string;
  repeat: boolean;
  options: any;
  isMultiple: boolean;
  minMultiple: number;
  maxMultiple: number;
  required: boolean;
}

interface ISelectExecutionState {
  selectComponent: any;
  valid: boolean[];
  valueSelect: number[];
}
export default class SelectExecutionComponent extends React.Component<ISelectExecutionProps, ISelectExecutionState> {
  constructor(props: ISelectExecutionProps) {
    super(props);
    this.state = {
      selectComponent: this.props.options,
      valid: [true],
      valueSelect: []
    }
  }
  componentDidMount() {
    const { defaultValue } = this.props;
    if (defaultValue)
      this.setState({ valueSelect: defaultValue })
  }
  //#region  START HANDLES 
  handleSelectChange = (idx: any) => async (evt: any) => {
    let valueSelect = [...this.state.valueSelect]
    
    if(evt.target.checked){
      valueSelect.push(idx)
    }else{
      valueSelect = valueSelect.filter(v => v !== idx)
    }
    let valid = this.validationFunction(valueSelect)
    this.setState({ 
      valueSelect: valueSelect,
       valid: valid 
      },
      () => 
        this.props.onChange({
        id: this.props.id,
        value: valueSelect,
        validation: valid
      })
      )
  }

  handleSelectRadio = async (evt: any) => {
    const valueSelect: number[] = []
    valueSelect.push(evt.target.value)
    this.setState({ valueSelect: valueSelect })
    this.props.onChange({
      id: this.props.id,
      value: valueSelect,
    });
  }
  getOptionsRadio() {
    let options: JSX.Element[] = []
    this.props.options.forEach((e: any, i: number) => {
      options.push(
        <Radio key={`${this.props.id}_opt${i}`} style={radioStyle} value={i}>{e.value}</Radio>
      )
    })
    return options;
  }
  //#endregion

  validationFunction(valueSelect : any) {
    let valid
    if (this.props.isMultiple) {
      const count = valueSelect.length
      if (this.props.required || !this.props.required && count > 0) {
        valid = count >= this.props.minMultiple && count <= this.props.maxMultiple ? true : false;
      } else {
        valid = true
      }
    } else {
      valid = this.state.valueSelect && this.state.valueSelect.length > 0 ? true : false;
    }
    return [valid];
  }

  render() {
    const { defaultValue } = this.props;
    return (
      <Wrapper>
        <Form>
          <p>{this.props.description}</p>
          <FormItem>
            {this.props.isMultiple &&
              this.props.options.map((items: any, index: number) => (
                <div key={`${this.props.id}_cb${index}`}>
                  <FieldsValidation
                    type={TypesValidation.CHECKBOX}
                    messageValidation={I18n.l("common.fieldRequired")}
                    handleOnChange={this.handleSelectChange(index)}
                    titleCheckbox={items.value}
                    defaultValue={defaultValue && defaultValue.includes(index)}
                  />
                </div>
              ))
            }
            {!this.props.isMultiple &&
              <FieldsValidation
                type={TypesValidation.RADIO}
                messageValidation={I18n.l("common.fieldRequired")}
                handleOnChange={this.handleSelectRadio}
                radioOptions={this.getOptionsRadio()}
                defaultValue={defaultValue ? defaultValue[0] : null}
              />
            }
            <div>
              {!this.state.valid[0] &&
                <p style={{ color: 'red' }} >{I18n.l("common.fieldRequired")}</p>
              }
            </div>
          </FormItem>
        </Form>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    margin-bottom: 8px;
  }
`
